import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../firebase/firebase-config';
import { onAuthStateChanged } from 'firebase/auth';
import { fetchUserProfile } from '../services/userProfileService';
import { isProfileComplete } from '../utils/profileUtils';

// Create the UserContext
const UserContext = createContext();

// Custom hook to use the UserContext
export const useUser = () => {
  return useContext(UserContext);
};

// UserProvider component to wrap the app and provide the user state
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [profileComplete, setProfileComplete] = useState(false);
  const [loading, setLoading] = useState(true);
  const [blockingTenantLogin, setBlockingTenantLogin] = useState(false);

  useEffect(() => {
    const checkAuthState = async (authUser) => {
      if (authUser) {
        const userProfile = await fetchUserProfile(authUser.uid);

        if (userProfile) {
          setProfileComplete(isProfileComplete(userProfile));
          setUser(userProfile);
        }
      } else {
        setUser(null);
        setProfileComplete(false);
      }
      setLoading(false);
    };

    // Listen to auth state changes
    const unsubscribe = onAuthStateChanged(auth, checkAuthState);

    return () => unsubscribe();
  }, []);

  // Ensure setUser is passed in the value
  return (
    <UserContext.Provider
      value={{
        user,
        profileComplete,
        loading,
        setUser,
        setProfileComplete,
        blockingTenantLogin,
        setBlockingTenantLogin,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;
